import { getJsonApi, postJsonApi } from "../helpers";
import { GameState, PerformActionRequest } from "@shared/types";

export async function getState(): Promise<GameState> {
    return getJsonApi<GameState>("game/state/");
}

export async function performAction(
    actionAlias: string,
    objectAliases?: string[],
): Promise<GameState | undefined> {
    try {
        return postJsonApi<GameState, PerformActionRequest>("game/action/", {
            action: actionAlias,
            objects: objectAliases,
        });
    } catch {
        return undefined;
    }
}
